import { render, staticRenderFns } from "./governmentAffairsOffice.vue?vue&type=template&id=1fd5f526&scoped=true&"
import script from "./governmentAffairsOffice.vue?vue&type=script&lang=js&"
export * from "./governmentAffairsOffice.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=1fd5f526&prod&lang=scss&scoped=true&"
import style1 from "./governmentAffairsOffice.vue?vue&type=style&index=1&id=1fd5f526&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd5f526",
  null
  
)

export default component.exports